(function() {
  var nav = document.getElementById('navbar-compact');
  if (!nav) return;

  var THRESHOLD = 60; // px of scroll before showing
  var ticking = false;

  function update() {
    var y = window.pageYOffset
         || document.documentElement.scrollTop
         || document.body.scrollTop
         || 0;
    if (y > THRESHOLD) {
      if (!nav.classList.contains('visible')) nav.classList.add('visible');
    } else {
      if (nav.classList.contains('visible')) nav.classList.remove('visible');
    }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
